// src/components/HeroSlider.jsx
import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const slidesData = [
  {
    subtitle: "karmyogi Enterprise",
    title: "Precision Copper Solutions.",
    description: "Source High-Quality Pipes, Fittings, and Parts for Every Project.",
    img: "/static/img/slider/slider1.3.webp",
    shapeImg: "/static/img/shape/slider1.1.webp",
  },
  {
    subtitle: "karmyogi Enterprise",
    title: "Connecting Systems, Ensuring Flow",
    description: "From Pipes to Valves: Everything You Need for Copper Installation.",
    img: "/static/img/slider/slider2.3.webp",
    shapeImg: "/static/img/shape/slider2.1.webp",
  },
  {
    subtitle: "karmyogi Enterprise",
    title: "Optimize Your Supply Chain Today",
    description: "Reduce Lead Times with Our Ready-to-Ship Inventory of Copper Components.",
    img: "/static/img/slider/slider3.3.webp",
    shapeImg: "/static/img/shape/slider3.1.webp",
  },
];

const HeroSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
  };

  return (
    <div className="ca-slider-active-3">
      <Slider {...settings}>
        {slidesData.map((slide, index) => (
          <div className="ca-slider-3 cream-bg-3 p-relative z-index-1 fix" key={index}>
            <div className="ca-slider-3-shape d-none d-lg-block">
              <img src="/static/img/shape/ca-shape3.3_1.webp" alt="" />
              <div className="ca-slider-top-shape-img">
                <img src={slide.shapeImg} alt="Shape" />
              </div>
            </div>

            <div className="ca-slider-img-3 p-absolute">
              <img src={slide.img} alt="Slider visual" />
            </div>

            <div className="ca-line-shape3">
              <img src="/static/img/shape/ca-shape3.1_1.webp" alt="" />
            </div>

            <div className="ca-overlay-shape3 p-absolute">
              <img src="/static/img/shape/overlay-shape3.2.webp" alt="" />
            </div>

            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-10">
                  <div className="ca-hero-content-3">
                    <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
                      {slide.subtitle}
                    </h5>
                    <h1 className="ca-slider-heading theme-black-3 fnw-600 pt-20 pb-20">
                      {slide.title}
                    </h1>
                    <p className="pt-16 pb-32">{slide.description}</p>
                    <div className="hero3-btn">
                      <Link
                        to="/contact"
                        className="ca-btn-primary-3 theme-bg-3 text-white br-50"
                      >
                        Enquire now
                        <span>
                          <i className="fa-solid fa-angle-right"></i>
                        </span>
                      </Link>

                      <Link
                        to="/products"
                        className="ca-sec-primary-3 theme-color-3 br-50"
                      >
                        Discover More
                        <span>
                          <i className="fa-solid fa-angle-right"></i>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroSlider;
